module.exports = __webpack_public_path__ + "assets/img/ic-arrow-right-w.c8f168ab.svg";